module.exports = __webpack_public_path__ + "static/media/filled.222eff40.svg";